// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"header__headerWrapper___1GH9M","title":"header__title___2Hn4b","logo":"header__logo____Y2uz"};